import { render, staticRenderFns } from "./cqDataInfo.vue?vue&type=template&id=19abb4cc&scoped=true&"
import script from "./cqDataInfo.vue?vue&type=script&lang=js&"
export * from "./cqDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./cqDataInfo.vue?vue&type=style&index=0&id=19abb4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19abb4cc",
  null
  
)

export default component.exports